module.exports = __webpack_public_path__ + "img/2.41e98526.svg";